export enum DrillTableNamesEnum {
  'Overview' = 'Overview',
  'Log' = 'Log',
}
